import React from 'react';
import cn from 'classname';
import _isEmpty from 'lodash/isEmpty';

const Row = ({ row, hasViewAllPermission, topOffersCheckboxes }) => {

	if (_isEmpty(row)) {
		return <tr>
			<td colSpan={7} className="background-yellow" />
		</tr>;
	}
	const canCopyOfferId = topOffersCheckboxes && topOffersCheckboxes.can_copy_offer_id;
	const canCopyCategory = topOffersCheckboxes && topOffersCheckboxes.can_copy_category;

	return  (
		<tr>
			<td className={cn({ 'no-copy-col': !canCopyOfferId })}>{row.offer_id}</td>
			<td>{row.country_code}</td>
			<td>{row.offer}</td>
			<td className={cn({ 'no-copy-col': !canCopyCategory })}>{row.niche}</td>
			<td className="top-offers-table-approves_description">
				{row.approve_to_valid_percent || 0} % / {row.approve_to_total_percent || 0} %
			</td>
			<td className="no-copy-col">{row.status}</td>
			{
				hasViewAllPermission &&
				<td className="top-offers-table-leads_description">
					{row.total_count || 0} / {row.approved_count || 0}
				</td>
			}
		</tr>
	);
};

export default Row;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/top-offers/components/table/row.js